import { AuthAnalyticsMetadata } from '../../providers/auth-providers';
import { getAnalyticsObject } from './set-window';
import { AdditionalAttributes, TopLevelUIEventProperties } from './types';

/** Input for the trackEvent function */
export type TrackEventInput = TopLevelUIEventProperties & AdditionalAttributes;

/** Tracks an event. Sends to GASv3, as well as SegmentIO, Gtm, and Snowplow via the atl-analytics library. */
export const trackEvent = (
    eventName: string,
    eventProperties: TrackEventInput
) => {
    const analytics = getAnalyticsObject();

    if (analytics) {
        analytics.Tracking.trackEvent(eventName, {
            ...eventProperties,
            content_type: window?.__APP_INITIAL_STATE__?.contentType,
            content_ari: window?.__APP_INITIAL_STATE__?.contentAri,
            contentful_entry_id: window?.__APP_INITIAL_STATE__?.entry?.id,
            is_logged_in: AuthAnalyticsMetadata.isUserAuthenticated
        });
    }
};
